<template lang="pug">
    model-data-table(
        no-data-text='Sin tickets de venta.'
        no-remove
        param-search='number'
        ref="table"
        remind-key='pos-sale-list'
        v-bind="tableProps"
        @detail="submitShow"
        :no-actions="!$can('VIEW_DETAIL_SALE_TICKET')"
        )
        template(slot="actions" slot-scope="props")
          v-tooltip(left)
            v-btn(
              slot="activator"
              icon
              @click="cancelTicket(props.item)"
              v-if="props.item && props.item.g_state_id === 17")
              v-icon.error--text cancel
            span Anular Ticket
</template>

<script>
//-
import { mapActions, mapState } from 'vuex'
import { ModelDataTable } from '@/components/reusable_components/next'
//
import PosSaleModel from '@/models/POS/PosSale'
import filters from './filters'
import headers from './headers'
//-
export default {
    name: 'sale-ticket-list',
    components: {
        'model-data-table': ModelDataTable,
    },
    data() {
        return {
            loading: false,
            ticketToCancel: null,
        }
    },
    computed: {
        //
        ...mapState('AuthModule', ['user']),
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
        /**
         *
         */
        tableProps() {
            return {
                service: PosSaleModel,
                filters: filters({
                    g_branch_office_address: this.user.hr_employee
                        .g_branch_office.address,
                }),
                initialFilterValues: {
                    created_at_min: new Date().toISOString().substring(0, 10),
                },
                headers,
            }
        },
    },
    methods: {
        cancelTicket(posSale) {
            this.loading = true
            this.ticketToCancel = posSale
            this.resetSnackbarState()
            this.setMessageConfirmSnack('ANULAR')
            this.showSnackbar(
                'warning',
                'Advertencia',
                `¿Desea anular el ticket de venta n°${posSale.id} ?`
            )
        },
        async showSnackbar(type, title, message, callback = () => {}) {
            this.initSnackbar(this.fillSnack(type, title, message, false, 0))
            callback()
        },
        //
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),

        /**
         *
         */
        submitShow(event) {
            console.log('item: ', event)
            this.$router.push({
                name: 'sale-ticket-detail',
                params: { id: event.item.id },
            })
        },
    },
    watch: {
        async responseConfirm(message) {
            switch (message) {
                case 'ANULAR':
                    this.ticketToCancel
                        .delete()
                        .then(r => {
                            this.resetSnackbarState()
                            this.showSnackbar(
                                'success',
                                'Éxito',
                                'Ticket anulado exitosamente'
                            )
                            //
                            this.$nextTick(() => this.$refs.table.refresh())
                            this.ticketToCancel = null
                        })
                        .catch(e => {
                            let message =
                                e.response &&
                                e.response.data &&
                                e.response.data.message
                                    ? e.response.data.message
                                    : e.response &&
                                      e.response.data &&
                                      e.response.data.error
                                    ? e.response.data.error
                                    : e
                            this.resetSnackbarState()
                            this.showSnackbar('error', 'Error', message)
                        })
                        .finally(() => (this.loading = false))
            }
        },
    },
    beforeMount() {
        this.setTitleTopBar('Tickets de venta')
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_ALL_SALE_TICKET')) ctx.$router.push('/')
        })
    },
}
</script>

<style lang="scss"></style>
